/* React */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

/* Componentes y dependencias */
import Preloader from "../../utils/Preloader";
import { Button, TablePagination } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import FullPageLoading from "../../FullPageLoading";

import { toast } from "react-toastify";

/* Servicios */
import NoticiaService from "../../../services/Noticia.service";

import styles from "../layout.module.css";

const TablaBlog = () => {
  const [noticias, setNoticias] = useState({});
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    getNoticias();
  }, [page, limit]);

  const getNoticias = async () => {
    setLoading(true);
    try {
      const data = await NoticiaService.list(limit, page * limit);
      setNoticias(data.data);
      setTotal(data.total);
    } catch (error) {
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      {loading ? (
        <Preloader />
      ) : (
        <div className={styles.recentorders} style={{ display: "grid" }}>
          {/*<div
            style={{
              display: "inline-flex",
              margin: "20px 0",
              justifyContent: "inherit",
            }}
          >
            <h2 style={{ marginRight: "20px" }}>Blog</h2>
            <Button
              variant="outlined"
              color="success"
              onClick={() => navigate(`nuevo`)}
            >
              Nuevo
            </Button>
          </div>*/}
          <div style={{ overflowX: "auto" }}>
            <table>
              <thead>
                <tr>
                  <td>
                    <h1 style={{ marginRight: "20px", marginBottom: "20px" }}>
                      BLOG
                    </h1>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <Button
                      variant="outlined"
                      color="success"
                      onClick={() => navigate(`nuevo`)}
                    >
                      Nuevo
                    </Button>
                  </td>
                </tr>
              </thead>
              <thead>
                <tr>
                  <td style={{ fontWeight: "bold" }}>TITULO</td>
                  <td style={{ fontWeight: "bold" }}>CUERPO</td>
                  <td></td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {noticias.map((record, index) => {
                  const regex = /<[^>]'>/gim;
                  return (
                    <tr key={`${record.id}_${record.titulo}`}>
                      <td>{record.titulo}</td>
                      {/*<td dangerouslySetInnerHTML={{__html: record.cuerpoNoticia}} ></td>
                           <td>
                            <img src={null} alt="Imagen de la noticia" />
                          </td> */}
                      {/* <td>
                          <img src={null} alt="Imagen producto" />
                        </td> */}
                      <td>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: String(record.cuerpoNoticia)
                              .slice(0, 100)
                              .concat("..."),
                          }}
                          style={{
                            textAlign: "justify",
                            fontWeight: "light",
                          }}
                        ></p>
                      </td>
                      <td>
                        {" "}
                        <span
                          onClick={() => navigate(`editar/${record.id}`)}
                          className="material-icons-sharp"
                        >
                          {" "}
                          edit{" "}
                        </span>
                      </td>
                      <td>
                        {" "}
                        <span
                          className="material-icons-sharp"
                          onClick={() => navigate(`eliminar/${record.id}`)}
                        >
                          {" "}
                          delete{" "}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <TablePagination
            style={{ color: "var(--color-dark-variant)" }}
            component="div"
            classes="recent-orders"
            labelRowsPerPage="Items por página"
            count={total}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={limit}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      )}
    </>
  );
};

export default TablaBlog;
